import ChangePassword from './ChangePasswordContainer';

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/ChangePassword/index.js